import * as FRAGS from "@thatopen/fragments";
import * as OBC from "@thatopen/components";
import * as OBF from "@thatopen/components-front";
const getDecompositionTree = async (
    components: OBC.Components,
    model: FRAGS.FragmentsGroup,
    expressID: number,
    inverseAttributes: OBC.InverseAttribute[],
) => {
    const rows: any[] = [];
    const indexer = components.get(OBC.IfcRelationsIndexer);

    const entityAttrs = await model.getProperties(expressID);
    if (!entityAttrs) return rows;
    const { type } = entityAttrs;
    const entityRow = {
        data: {
            Entity: OBC.IfcCategoryMap[type],
            Name: entityAttrs.Name?.value,
            modelID: model.uuid,
            expressID,
            relations: undefined as string | undefined,

        },
        children: undefined as any[] | undefined
    };

    for (const attrName of inverseAttributes) {
        const relations = indexer.getEntityRelations(model, expressID, attrName);
        if (!relations) continue;
        if (!entityRow.children) entityRow.children = [];
        entityRow.data.relations = JSON.stringify(relations);
        const entityGroups: any = {};
        for (const id of relations) {
            const decompositionRow = await getDecompositionTree(
                components,
                model,
                id,
                inverseAttributes,
            );
            for (const row of decompositionRow) {
                // console.log(row);
                if (row.data.relations) {
                    entityRow.children.push(row);
                } else {
                    const data = model.data.get(id);
                    if (!data) {
                        entityRow.children.push(row);
                        continue;
                    }
                    const type = data[1][1];
                    const entity = OBC.IfcCategoryMap[type];
                    if (!(entity in entityGroups)) entityGroups[entity] = [];
                    row.data.Entity = row.data.Name;
                    delete row.data.Name;
                    entityGroups[entity].push(row);
                }
            }
        }

        for (const entity in entityGroups) {
            const children = entityGroups[entity];
            const relations = children.map((child: any) => child.data.expressID);
            const row: any = {
                data: {
                    Entity: entity,
                    modelID: model.uuid,
                    relations: JSON.stringify(relations),
                },
                children,
            };
            entityRow.children.push(row);
        }
    }

    rows.push(entityRow);

    return rows;
};
export default getDecompositionTree;